import { usePost } from '../../HttpClient';
import { CalendarModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateCalendar() {
  const post = usePost(true, "tms");
  const createCalendar = (calendar: CalendarModel) => post(`${referenceDataBaseUrl}/calendars`, calendar);
  return useMutationWithErrorHandling({
    mutationFn: async (calendar: CalendarModel) => await createCalendar(calendar),
  });
}
